"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryTypes = exports.LiquidityRegistryTypes = exports.CosmwasmRegistryTypes = exports.CosmosRegistryTypes = exports.CyberRegistryTypes = void 0;
var CyberRegistryTypes;
(function (CyberRegistryTypes) {
    CyberRegistryTypes["MsgCyberlink"] = "/cyber.graph.v1beta1.MsgCyberlink";
    CyberRegistryTypes["MsgInvestmint"] = "/cyber.resources.v1beta1.MsgInvestmint";
    CyberRegistryTypes["MsgCreateRoute"] = "/cyber.grid.v1beta1.MsgCreateRoute";
    CyberRegistryTypes["MsgEditRoute"] = "/cyber.grid.v1beta1.MsgEditRoute";
    CyberRegistryTypes["MsgEditRouteName"] = "/cyber.grid.v1beta1.MsgEditRouteName";
    CyberRegistryTypes["MsgDeleteRoute"] = "/cyber.grid.v1beta1.MsgDeleteRoute";
})(CyberRegistryTypes = exports.CyberRegistryTypes || (exports.CyberRegistryTypes = {}));
var CosmosRegistryTypes;
(function (CosmosRegistryTypes) {
    CosmosRegistryTypes["MsgDeposit"] = "/cosmos.gov.v1beta1.MsgDeposit";
    CosmosRegistryTypes["MsgExec"] = "/cosmos.authz.v1beta1.MsgExec";
    CosmosRegistryTypes["MsgGrant"] = "/cosmos.authz.v1beta1.MsgGrant";
    CosmosRegistryTypes["MsgRevoke"] = "/cosmos.authz.v1beta1.MsgRevoke";
})(CosmosRegistryTypes = exports.CosmosRegistryTypes || (exports.CosmosRegistryTypes = {}));
var CosmwasmRegistryTypes;
(function (CosmwasmRegistryTypes) {
    CosmwasmRegistryTypes["MsgClearAdmin"] = "/cosmwasm.wasm.v1beta1.MsgClearAdmin";
    CosmwasmRegistryTypes["MsgMigrateContract"] = "/cosmwasm.wasm.v1beta1.MsgMigrateContract";
    CosmwasmRegistryTypes["MsgUpdateAdmin"] = "/cosmwasm.wasm.v1beta1.MsgUpdateAdmin";
    CosmwasmRegistryTypes["MsgExecuteContract"] = "/cosmwasm.wasm.v1.MsgExecuteContract";
    CosmwasmRegistryTypes["MsgInstantiateContract"] = "/cosmwasm.wasm.v1.MsgInstantiateContract";
    CosmwasmRegistryTypes["MsgStoreCode"] = "/cosmwasm.wasm.v1.MsgStoreCode";
})(CosmwasmRegistryTypes = exports.CosmwasmRegistryTypes || (exports.CosmwasmRegistryTypes = {}));
var LiquidityRegistryTypes;
(function (LiquidityRegistryTypes) {
    LiquidityRegistryTypes["MsgSwapWithinBatch"] = "/cyber.liquidity.v1beta1.MsgSwapWithinBatch";
    LiquidityRegistryTypes["MsgDepositWithinBatch"] = "/cyber.liquidity.v1beta1.MsgDepositWithinBatch";
    LiquidityRegistryTypes["MsgWithdrawWithinBatch"] = "/cyber.liquidity.v1beta1.MsgWithdrawWithinBatch";
    LiquidityRegistryTypes["MsgCreatePool"] = "/cyber.liquidity.v1beta1.MsgCreatePool";
})(LiquidityRegistryTypes = exports.LiquidityRegistryTypes || (exports.LiquidityRegistryTypes = {}));
exports.RegistryTypes = {
    cyber: CyberRegistryTypes,
    cosmos: CosmosRegistryTypes,
    cosmwasm: CosmwasmRegistryTypes,
    liquidity: LiquidityRegistryTypes,
};
//# sourceMappingURL=registryTypes.js.map